(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-main-product]').forEach(function (root) {
      var mainImage = root.querySelector('[data-gallery-main-image]');
      var variantInput = root.querySelector('[data-variant-input]');
      var priceEl = root.querySelector('[data-selected-price]');
      var compareAtEl = root.querySelector('[data-compare-at-price]');
      var addButton = root.querySelector('[data-add-to-cart]');
      var addLabel = root.querySelector('[data-add-to-cart-label]');
      var qtyInput = root.querySelector('[data-quantity-input]');
      var qtyValue = root.querySelector('[data-qty-value]');
      var stickyPrice = root.querySelector('[data-sticky-price]');
      var stickySize = root.querySelector('[data-sticky-size]');
      var galleryStage = root.querySelector('[data-gallery-stage]');
      var galleryPrevious = root.querySelector('[data-gallery-previous]');
      var galleryNext = root.querySelector('[data-gallery-next]');
      var galleryCurrent = root.querySelector('[data-gallery-current]');
      var galleryThumbnails = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumbnail]'));
      var currentGalleryIndex = 0;

      function setImage(url, alt) {
        if (!url || !mainImage) return;

        mainImage.src = url;
        if (alt) mainImage.alt = alt;
      }

      function showGallerySlide(index) {
        if (galleryThumbnails.length === 0) return;

        currentGalleryIndex = (index + galleryThumbnails.length) % galleryThumbnails.length;

        galleryThumbnails.forEach(function (thumbnail, thumbnailIndex) {
          var isActive = thumbnailIndex === currentGalleryIndex;
          thumbnail.classList.toggle('main-product__thumbnail--active', isActive);

          if (isActive) {
            thumbnail.setAttribute('aria-current', 'true');
          } else {
            thumbnail.removeAttribute('aria-current');
          }
        });

        var activeThumbnail = galleryThumbnails[currentGalleryIndex];
        var thumbnailImage = activeThumbnail.querySelector('img');
        setImage(activeThumbnail.getAttribute('data-full-image'), thumbnailImage ? thumbnailImage.alt : '');

        if (galleryCurrent) galleryCurrent.textContent = String(currentGalleryIndex + 1);

        if (typeof activeThumbnail.scrollIntoView === 'function') {
          activeThumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      galleryThumbnails.forEach(function (thumb, thumbIndex) {
        thumb.addEventListener('click', function () {
          showGallerySlide(thumbIndex);
        });
      });

      if (galleryPrevious) {
        galleryPrevious.addEventListener('click', function () {
          showGallerySlide(currentGalleryIndex - 1);
        });
      }

      if (galleryNext) {
        galleryNext.addEventListener('click', function () {
          showGallerySlide(currentGalleryIndex + 1);
        });
      }

      if (galleryStage && galleryThumbnails.length > 1) {
        galleryStage.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            showGallerySlide(currentGalleryIndex - 1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            showGallerySlide(currentGalleryIndex + 1);
          }
        });

        var galleryTouchStartX = null;

        galleryStage.addEventListener(
          'touchstart',
          function (event) {
            galleryTouchStartX = event.changedTouches[0].clientX;
          },
          { passive: true }
        );

        galleryStage.addEventListener(
          'touchend',
          function (event) {
            if (galleryTouchStartX === null) return;

            var distance = event.changedTouches[0].clientX - galleryTouchStartX;
            galleryTouchStartX = null;

            if (Math.abs(distance) < 45) return;
            showGallerySlide(distance > 0 ? currentGalleryIndex - 1 : currentGalleryIndex + 1);
          },
          { passive: true }
        );
      }

      function updateAddLabel() {
        if (!addLabel || !priceEl || !addButton) return;
        var template = addButton.getAttribute('data-label-template') || '__PRICE__';
        addLabel.textContent = template.replace('__PRICE__', priceEl.textContent);
      }

      function selectVariant(button) {
        root.querySelectorAll('[data-size-option]').forEach(function (b) {
          b.classList.remove('main-product__size--active');
        });
        button.classList.add('main-product__size--active');

        var id = button.getAttribute('data-variant-id');
        var price = button.getAttribute('data-price');
        var compareAt = button.getAttribute('data-compare-at');
        var showCompareAt = button.getAttribute('data-show-compare-at') === 'true';
        var title = button.getAttribute('data-title');
        var available = button.getAttribute('data-available') === 'true';
        var image = button.getAttribute('data-full-image');

        if (variantInput) variantInput.value = id;
        if (priceEl) priceEl.textContent = price;
        if (compareAtEl) {
          if (showCompareAt) {
            compareAtEl.textContent = compareAt;
            compareAtEl.hidden = false;
          } else {
            compareAtEl.hidden = true;
          }
        }
        if (addButton) addButton.disabled = !available;
        if (image) {
          var matchingGalleryIndex = galleryThumbnails.findIndex(function (thumbnail) {
            return thumbnail.getAttribute('data-full-image') === image;
          });

          if (matchingGalleryIndex >= 0) {
            showGallerySlide(matchingGalleryIndex);
          } else {
            setImage(image, title);
            galleryThumbnails.forEach(function (thumbnail) {
              thumbnail.classList.remove('main-product__thumbnail--active');
              thumbnail.removeAttribute('aria-current');
            });
          }
        }
        if (stickyPrice) stickyPrice.textContent = price;
        if (stickySize) stickySize.textContent = title;
        updateAddLabel();
      }

      root.querySelectorAll('[data-size-option]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectVariant(button);
        });
      });

      var qty = 1;
      function renderQty() {
        if (qtyValue) qtyValue.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
      }
      var decreaseBtn = root.querySelector('[data-qty-decrease]');
      var increaseBtn = root.querySelector('[data-qty-increase]');
      if (decreaseBtn)
        decreaseBtn.addEventListener('click', function () {
          qty = Math.max(1, qty - 1);
          renderQty();
        });
      if (increaseBtn)
        increaseBtn.addEventListener('click', function () {
          qty = qty + 1;
          renderQty();
        });

      var form = document.getElementById('main-product-form');
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          if (!window.Belgravia || !variantInput) return;
          window.Belgravia.addToCart(
            { id: variantInput.value, quantity: qtyInput ? qtyInput.value : 1 },
            root.dataset.productTitle
          );
        });
      }

      // "Smells Like" media — reveal and play the inline film on demand.
      var notesMedia = root.querySelector('[data-notes-media]');
      var notesPlay = root.querySelector('[data-notes-play]');
      var notesVideo = root.querySelector('[data-notes-video]');
      if (notesMedia && notesPlay && notesVideo) {
        notesPlay.addEventListener('click', function () {
          notesMedia.classList.add('is-playing');
          notesVideo.setAttribute('controls', 'controls');
          var playAttempt = notesVideo.play();
          if (playAttempt && typeof playAttempt.catch === 'function') {
            playAttempt.catch(function () {});
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
